import { environment } from '@environments/environment';

export const GTM_EVENT_CONSTANT = {
  STEP_1: 'register_step_1_success',
  STEP_1_VALIDATION_FAILED: 'register_step_1_validation_failed',
  STEP_2: 'register_step_2_success',
  STEP_2_VALIDATION_FAILED: 'register_step_2_validation_failed',
  STEP_2_SERVER_ERROR: 'register_step_2_server_error',
  STEP_2_OTP_VERIFIED: 'register_step_2_otp_verified',
  STEP_3_VALIDATION_FAILED: 'register_step_3_validation_failed',
  STEP_3: 'register_step_3_success',
  STEP_3_SERVER_ERROR: 'register_step_3_server_error'
}

export const INDUSTRY_LIST = [
  { key: 'create_partner_component.industry_options.banken_finanzwesen', value: 'banking' },
  { key: 'create_partner_component.industry_options.behörden_verwaltungen', value: 'administrations' },
  { key: 'create_partner_component.industry_options.bildungseinrichtungen', value: 'education' },
  { key: 'create_partner_component.industry_options.dienstleistungsbranche', value: 'services' },
  { key: 'create_partner_component.industry_options.einzelhandel_ecommerce', value: 'ecommerce' },
  { key: 'create_partner_component.industry_options.eventmanagement_veranstaltungen', value: 'event_management' },
  { key: 'create_partner_component.industry_options.gesundheitswesen_medizin', value: 'health' },
  { key: 'create_partner_component.industry_options.immobilien_bauwesen', value: 'real_estate' },
  { key: 'create_partner_component.industry_options.personalwesen_recruiting', value: 'hr' },
  { key: 'create_partner_component.industry_options.rechtswesen_kanzleien', value: 'law' },
  { key: 'create_partner_component.industry_options.schönheit_wellness', value: 'beauty' },
  { key: 'create_partner_component.industry_options.sport_fitness', value: 'sport' },
  { key: 'create_partner_component.industry_options.unternehmensberatung', value: 'consulting' },
  { key: 'create_partner_component.industry_options.versicherungen_vorsorge', value: 'insurance' },
  { key: 'create_partner_component.industry_options.sonstigebranchen', value: 'other' }
];

export const COMPANY_SIZE = [
  { key: '1-3', value: '1-3' },
  { key: '4-10', value: '4-10' },
  { key: '11-25', value: '11-25' },
  { key: '26-50', value: '26-50' },
  { key: '51-250', value: '51-250' },
  { key: '251-500', value: '251-500' },
  { key: '501-1000', value: '501-1000' },
  { key: '1001-5000', value: '1001-5000' },
  { key: '5001-20000', value: '5001-20000' },
  { key: '20001-50000', value: '20001-50000' },
  { key: '50001-100000', value: '50001-100000' },
  { key: '0', value: '0' }
];

// Phone-input config per deployment region. Each environment declares its `region`
// (see environment.*.ts); the phone input picks the matching fallback country and
// preferred-country ordering from here. Add a region key when onboarding a new market.
export const REGION_PHONE_CONFIG: Record<string, { defaultCountry: string; preferredCountries: string[] }> = {
  eu: {
    defaultCountry: 'ch',
    preferredCountries: ['ch', 'de', 'fr', 'gb', 'it', 'nl', 'fi', 'pl', 'es', 'se', 'at'],
  },
  us: {
    defaultCountry: 'us',
    preferredCountries: ['us', 'ca'],
  },
};

export const INTL_TEL_INPUT = {
  // Backend-proxied geo lookup — keeps the upstream provider token off the public bundle
  IPLOOKUP_URL: `${environment.hostName}/api/v1/geo/lookup`
};

// null = accept any valid phone number type (mobile, landline, VOIP, toll-free, etc.)
// Restricting to specific types like ["MOBILE", "FIXED_LINE"] would reject numbers
// classified as FIXED_LINE_OR_MOBILE (ambiguous) — common in US, Canada, and others.
export const INTL_TEL_INPUT_VALIDATION_NUMBER_TYPES = null;

export type PartnerRegistrationMode = 'PLG' | 'SLG';

export const PARTNER_REGISTRATION_MODE = {
  PLG: 'PLG' as PartnerRegistrationMode,
  SLG: 'SLG' as PartnerRegistrationMode
} as const;
